import {getRequest} from "./api";
import Router from "vue-router";
import Login from "../views/Login";
import Home from "../views/Home";
import FriendChat from "../views/chat/FriendChat";
import HrInfo from "../views/HrInfo";
import BillDetails from "../views/bill/BillDetails";
import BillTotals from "../views/bill/BillTotals";
import NormalSkd from "../views/bill/NormalSkd";
import FixSkd from "../views/bill/FixSkd";
import BillDown from "../views/bill/BillDown";
import BillMchInfo from "../views/bill/BillMchInfo";

/*****************************************************
 初始化菜单
 ******************************************************/
const resetRouter = () => new Router (
    {
        routes: [                   // 配置路由数组
            { // 每一个链接都是一个对象
                path: '/',          // 链接路径
                name: 'Login',      // 路由名称
                component: Login,   // 对应的组件
                hidden:true         //
            },
            { // 每一个链接都是一个对象
                path: '/home',
                name: 'Home',
                component: Home,
                hidden:true,
                meta:
                    {
                        roles:['admin','user']
                    },
                children:[ // 子路由,嵌套路由
                    {
                        path: '/chat',
                        name: '在线聊天',
                        component: FriendChat,
                        hidden:true
                    },
                    {
                        path: '/hrinfo',
                        name: '个人中心',
                        component: HrInfo,
                        hidden:true
                    },
                    { // 为商户账务系统临时添加，不好的方式。
                        path: '/BillDetails',
                        name: '交易明细',
                        component: BillDetails,
                        hidden:true
                    },
                    { // 为商户账务系统临时添加，不好的方式。
                        path: '/BillTotals',
                        name: '交易汇总',
                        component: BillTotals,
                        hidden:true
                    },
                    { // 为商户账务系统临时添加，不好的方式。
                        path: '/NormalSkd',
                        name: '普通收款单', // '',
                        component: NormalSkd,
                        hidden:true
                    },
                    { // 为商户账务系统临时添加，不好的方式。
                        path: '/FixSkd',
                        name: '固定收款单', // '',
                        component: FixSkd,
                        hidden:true
                    },
                    { // 为商户账务系统临时添加，不好的方式。
                        path: '/BillMchInfo',
                        name: '商户信息',
                        component: BillMchInfo,
                        hidden:true
                    }
                ]
            }
        ]
    }
)

export const initMenu = (router, store) => {
//    console.log("当前路由数："+ store.state.routes.length);
    if (store.state.routes.length > 0) {
        return;
    }
    /*****************************************************
     Request菜单数据
     ******************************************************/
    getRequest("/system/config/menu").then(data => {
        if (data) {
            let fmtRoutes = formatRoutes(data, store);     // 解析菜单数据           formatRoutes(jsonData)

            // console.log("fmtRoutes", JSON.stringify(fmtRoutes))

            router.matcher = resetRouter().matcher;
            router.addRoutes(fmtRoutes);            // 菜单数据添加到router    addRoutes(fmtRoutes)
            store.commit('initRoutes', fmtRoutes);  // 同步提交到全局仓库

            // store.dispatch('connect');              // 通过 store.dispatch 方法触发actions.'connect'...chat...
        }
    })
}

/*****************************************************
 解析菜单数据 JsonData -> routesData
 ******************************************************/
export const formatRoutes = (routes, store) => {
    let fmRoutes = [];

    // 循环解析Json数组
    routes.forEach(router => {
        let {
            path,
            component,
            name,
            meta,
            iconCls,
            children
        } = router;

        /*
        if (!component) {
            router = formatRoutes(children);
        }*/

        // 递归解析子菜单数据
        if (component && children && children instanceof Array) {
            children = formatRoutes(children, store);
        }



        let fmRouter = {
            path: path,             // 路径
            name: name,             // 名称
            iconCls: iconCls,       // 图标
            meta: meta,             // 属性
            children: children,     // 子菜单
            component(resolve) {    // 组件
                if (component.startsWith("Home")) {
                    require(['../views/' + component + '.vue'], resolve);
                } else if (component.startsWith("Bill")) {
                    require(['../views/bill/' + component + '.vue'], resolve);
                }  else if (component.startsWith("Emp")) {
                    require(['../views/emp/' + component + '.vue'], resolve);
                } else if (component.startsWith("Per")) {
                    require(['../views/per/' + component + '.vue'], resolve);
                } else if (component.startsWith("Prod")) {
                    require(['../views/prod/' + component + '.vue'], resolve);
                } else if (component.startsWith("Sys")) {
                    require(['../views/sys/' + component + '.vue'], resolve);
                } else if (component.startsWith("Dev")) {  // 当组件名称以Dev开头，引入dev目录下component名称的vue组件
                    require(['../views/dev/' + component + '.vue'], resolve);
                } else if (component.startsWith("Qr")) {  // 当组件名称以Dev开头，引入dev目录下component名称的vue组件
                    require(['../views/qr/' + component + '.vue'], resolve);
                } else if (component.startsWith("Agent")) {
                    require(['../views/agent/' + component + '.vue'], resolve);
                } else if (component.startsWith("Mch")) {
                    require(['../views/mch/' + component + '.vue'], resolve);
                } else if (component.startsWith("Sal")) {
                    require(['../views/sal/' + component + '.vue'], resolve);
                } else if (component.startsWith("RptMch")) { // 商户报表
                    require(['../views/rpt/mch/' + component + '.vue'], resolve);
                } else if (component.startsWith("RptDev")) { // 设备报表
                    require(['../views/rpt/dev/' + component + '.vue'], resolve);
                } else if (component.startsWith("RptSal")) { // 客户经理报表
                    require(['../views/rpt/sal/' + component + '.vue'], resolve);
                } else if (component.startsWith("RptAll")) { // 公司用的报表
                    require(['../views/rpt/all/' + component + '.vue'], resolve);
                }
            }
        }

        // console.log("agentLevel", store.state.currentHr.agentLevel)
        // console.log(fmRouter.name)

        if (fmRouter.name==="服务商管理") {
            if (store.state.currentHr.agentLevel < 2) {
                fmRoutes.push(fmRouter); // 添加一个route
            }
        }
        else {
            fmRoutes.push(fmRouter); // 添加一个route
        }
    })
    return fmRoutes; // 返回routes
}
